import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Alert, AlertDescription, AlertIcon, AlertTitle, Badge, Box, Button, Divider, Flex, FormControl, FormHelperText, FormLabel, HStack, Image, Input, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { addCompanyWebsiteRequest, deleteCompanyWebsiteRequest, getCompanyWebsiteRequest, updateCompanyWebsiteRequest } from '../../store/actions';
import { companyRequestWebsiteFormValidation, filterByStatus } from '../../utils';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import Template1 from '../../theme/assets/website-template1.jpg';
// import Template2 from '../../theme/assets/website-template2.jpg';
import { ToastContainer } from 'react-toastify';
import { requestCompanyWebsite } from '../../types';
import { useFormik } from 'formik';
import { usePaystackPayment } from 'react-paystack';

type templateType = {
    template_id?: string;
    package?: string;
    amount?: number | string;
    image?: string;
    url?: string;
    is_special?: boolean;
    special_amount?: number;
};

export const RequestWebsite = () => {

    const [templates] = useState<Array<templateType>>([
        {
            template_id: 'TMP-48564',
            package: 'starter',
            is_special: true,
            special_amount: 0,
            amount: 1500,
            image: Template1,
            url: 'https://starter-template.trucklivery.com/'
        },
        // {
        //     template_id: 'TMP-48565',
        //     package: 'standard',
        //     amount: 2000,
        //     image: Template2,
        //     url: 'https://www.google.com'
        // }
    ]);

    const [amount, setAmount] = useState<number>(5);

    const { user } = useAppSelector(state => state.userReducer);

    const { company_websites_request, is_updating_company_website_request, is_adding_company_website_request, is_deleting_company_website_request } = useAppSelector(state => state.companyWebsiteRequest);

    const dispatch: AppDispatch = useAppDispatch();

    const websiteForm = useFormik({
        initialValues: {
            phone: '',
            email: '',
            domain_name: '',
            amount: '',
            template_id: ''
        },
        validationSchema: companyRequestWebsiteFormValidation,
        validateOnBlur: true,
        onSubmit: (values: requestCompanyWebsite) => {
            dispatch(addCompanyWebsiteRequest(values)).then(() => { dispatch(getCompanyWebsiteRequest()); resetForm(); });
            // alert(JSON.stringify(values, null, 2));
        }
    });

    const config: any = {
        firstname: String(user?.first_name),
        lastname: String(user?.last_name),
        phone: String(user?.phone),
        email: String(user?.email),
        amount: Number(`${amount}00`),
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLICK_KEY,
        currency: 'ZAR',
    };

    const initializePayment = usePaystackPayment(config);

    const _onClose = () => {
        console.log('closed');
    };

    const handleSetAmount = async (amount: number) => {
        setAmount(amount);
    };

    const handlePayment = async (values: requestCompanyWebsite) => {
        await handleSetAmount(Number(values?.amount));
        initializePayment((reference: void) => {
            const data: any = reference;
            const _values = { ...values, payment_status: 'paid', payment_reference: String(data?.reference) };
            dispatch(updateCompanyWebsiteRequest(_values)).then(() => dispatch(getCompanyWebsiteRequest()));
        }, _onClose);
    };

    const handleRequestCancel = (request: requestCompanyWebsite) => {
        const values = { ...request, status: 'cancelled' };
        dispatch(updateCompanyWebsiteRequest(values)).then(() => dispatch(getCompanyWebsiteRequest()));
    };

    const handleRequestPending = (request: requestCompanyWebsite) => {
        const values = { ...request, status: 'pending' };
        dispatch(updateCompanyWebsiteRequest(values)).then(() => dispatch(getCompanyWebsiteRequest()));
    };

    const handleRequestDelete = (id: string) => {
        dispatch(deleteCompanyWebsiteRequest(id)).then(() => dispatch(getCompanyWebsiteRequest()));
    };

    const handleSelectTemplate = (amount: number | string, template_id: string) => {
        websiteForm.setFieldValue('amount', amount);
        websiteForm.setFieldValue('template_id', template_id);
    };

    const resetForm = () => websiteForm.resetForm();

    useEffect(() => {
        dispatch(getCompanyWebsiteRequest());
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                // bg={useColorModeValue('gray.50', 'gray.800')}
                py={10}
            >
                <Stack>
                    {
                        company_websites_request?.filter((request: requestCompanyWebsite) => request.status === 'pending')?.length &&
                        <Alert status='success' variant='subtle' shadow={'sm'} mb={2} borderRadius={6}>
                            <AlertIcon />
                            <Box>
                                <AlertTitle>Success!</AlertTitle>
                                <AlertDescription>
                                    Your application has been received. We will review your application
                                    and respond within the next few hours.
                                </AlertDescription>
                            </Box>
                        </Alert>
                    }
                    {
                        company_websites_request?.filter((request: requestCompanyWebsite) => request.status === 'approved' && request?.payment_status === 'paid')?.length &&
                        <Alert status='success' variant='subtle' shadow={'sm'} mb={2} borderRadius={6}>
                            <AlertIcon />
                            <Box>
                                <AlertTitle>Payment Success!</AlertTitle>
                                <AlertDescription>
                                    Your payment has been received. We&apos;re busy setting up your website and it will be active in the next 2-3 days.
                                </AlertDescription>
                            </Box>
                        </Alert>
                    }
                    {
                        company_websites_request?.filter((request: requestCompanyWebsite) => request.status === 'cancelled')?.length &&
                        <Alert status='warning' shadow={'sm'} mb={3} borderRadius={6}>
                            <AlertIcon />
                            Cancellation received, if you change your mind and you want to register your business domain, please contact us on 0761958601.
                        </Alert>
                    }
                    {
                        company_websites_request.length &&
                        <Accordion defaultIndex={[0]} allowMultiple bg={'#FFFFFF'} borderRadius={6}>
                            <AccordionItem>
                                <h2>
                                    <AccordionButton _hover={{ bg: '#fff8e1' }}>
                                        <Box flex='1' textAlign='left'>
                                            <Text fontWeight={'medium'}>Company website requests: Total <Badge>{company_websites_request?.length}</Badge></Text>
                                            <HStack mt={2}>
                                                {filterByStatus(company_websites_request, 'pending')?.length && <Badge colorScheme='green'>pending {filterByStatus(company_websites_request, 'pending')?.length}</Badge>}
                                                {filterByStatus(company_websites_request, 'cancelled')?.length && <Badge colorScheme='red'>cancelled {filterByStatus(company_websites_request, 'cancelled')?.length}</Badge>}
                                                {filterByStatus(company_websites_request, 'approved')?.length && <Badge colorScheme='green'>approved {filterByStatus(company_websites_request, 'approved')?.length}</Badge>}
                                                {filterByStatus(company_websites_request, 'completed')?.length && <Badge colorScheme='green'>completed {filterByStatus(company_websites_request, 'completed')?.length}</Badge>}
                                            </HStack>
                                        </Box>
                                        <AccordionIcon />
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4} bg={'#f5f5f5'}>
                                    {
                                        company_websites_request?.length &&
                                        <>
                                            {
                                                company_websites_request?.map((request: requestCompanyWebsite, index: number) => (
                                                    <HStack key={index} bg={'#FFFFFF'} px={3} py={2} justifyContent={'space-between'} borderRadius={4} shadow={'sm'}>
                                                        <Stack>
                                                            <Text fontWeight={'medium'} fontSize={16}>{request?.domain_name} <Badge colorScheme={request?.status === 'cancelled' ? 'red' : 'green'}>{request?.status}</Badge></Text>
                                                            <HStack>
                                                                <Text fontWeight={'light'}>{request?.request_id}</Text>
                                                                <Badge colorScheme={request?.payment_status === 'paid' ? 'green' : 'gray'}>{request?.payment_status === 'paid' ? 'Paid' : 'Unpaid'}</Badge>
                                                            </HStack>
                                                        </Stack>
                                                        <HStack>
                                                            {request?.status === 'approved' && request?.payment_status === 'unpaid' && <Button colorScheme='green' size={'sm'} onClick={() => handlePayment(request)} >Pay {request?.amount}</Button>}
                                                            {request?.status === 'cancelled' && <Button colorScheme='yellow' size={'sm'} onClick={() => handleRequestPending(request)} >Re-Send Request</Button>}
                                                            {request?.status === 'cancelled' && <Button loadingText='Deleting' colorScheme='red' size={'sm'} onClick={() => handleRequestDelete(`${request?.request_id}`)} disabled={is_updating_company_website_request || is_deleting_company_website_request} isLoading={is_updating_company_website_request || is_deleting_company_website_request} >Delete</Button>}
                                                            {(request?.status === 'pending' || request?.status === 'approved') && <Button loadingText={'cancelling'} colorScheme='red' size={'sm'} onClick={() => handleRequestCancel(request)} isLoading={is_updating_company_website_request || is_deleting_company_website_request} disabled={is_updating_company_website_request || is_deleting_company_website_request || request?.payment_status === 'paid'}>{'Cancel'}</Button>}
                                                        </HStack>
                                                    </HStack>
                                                ))
                                            }
                                        </>
                                    }
                                </AccordionPanel>
                            </AccordionItem>
                        </Accordion>
                    }
                    <Box
                        rounded={'lg'}
                        bg={useColorModeValue('white', 'gray.700')}
                        boxShadow={'lg'}
                        p={8}>
                        <Stack spacing={4}>
                            <HStack align={'center'} alignSelf={'center'}>
                                <Stack>
                                    <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                        Request company website.
                                    </Text>
                                </Stack>
                            </HStack>
                            <Divider />
                            <Stack mb={3}>
                                <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                    Create your business website with our partners <a href='https://www.google.com' target={'_blank'} rel={'noreferrer'}>company name</a>, for R1500✌️
                                </Text>
                            </Stack>
                            <HStack justifyContent={'center'} pb={4}>
                                {
                                    templates?.map((template: templateType, index: number) => (
                                        <Stack key={index} p={3} shadow={'md'} bg={'#fafafa'}>
                                            <Image w={150} h={100} src={template.image} alt={template.template_id} />
                                            <HStack justifyContent={'space-between'}>
                                                <Text fontSize={14} textTransform={'capitalize'} fontWeight={'medium'}>{template?.package}</Text>
                                                <HStack>
                                                    <Text fontSize={14} textTransform={'capitalize'} fontWeight={'bold'} color={template?.is_special ? '#f44336' : '#4caf50'} textDecoration={template?.is_special ? 'line-through' : 'none'}>R{template?.amount}</Text>
                                                    <Text fontSize={14} textTransform={'capitalize'} fontWeight={'bold'} color={'#4caf50'}>R{template?.special_amount}</Text>
                                                </HStack>
                                            </HStack>
                                            <Stack>
                                                <Button size={'xs'} variant={'outline'} onClick={() => window.open(template?.url)}>Preview</Button>
                                                <Button size={'xs'} variant={'solid'} onClick={() => handleSelectTemplate(`${template?.is_special ? template?.special_amount : template?.amount}`, `${template?.template_id}`)} colorScheme={template?.template_id === websiteForm.values.template_id ? 'green' : 'gray'}>{template?.template_id === websiteForm.values.template_id ? 'Selected' : 'Select'}</Button>
                                            </Stack>
                                        </Stack>
                                    ))
                                }
                            </HStack>
                            <Stack>
                                {websiteForm.errors.template_id && <Text textAlign={'center'} fontSize='sm' color='red.400'>{websiteForm.errors.template_id}</Text>}
                            </Stack>
                            <form onSubmit={websiteForm.handleSubmit} style={{ justifyContent: 'center', display: 'grid' }}>
                                <HStack>
                                    <Box>
                                        <FormControl id="phone" isRequired mb={websiteForm.errors.phone ? 0 : 5}>
                                            <FormLabel>Phone number</FormLabel>
                                            <Input name='phone' type="text" value={websiteForm.values.phone} onChange={websiteForm.handleChange} onBlur={websiteForm.handleBlur} />
                                            {websiteForm.errors.phone && <Text fontSize='sm' color='red.400'>{websiteForm.errors.phone}</Text>}
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <FormControl id="email" isRequired mb={websiteForm.errors.email ? 0 : 5}>
                                            <FormLabel>Email</FormLabel>
                                            <Input name='email' type="email" value={websiteForm.values.email} onChange={websiteForm.handleChange} onBlur={websiteForm.handleBlur} />
                                            {websiteForm.errors.email && <Text fontSize='sm' color='red.400'>{websiteForm.errors.email}</Text>}
                                        </FormControl>
                                    </Box>
                                </HStack>
                                <HStack>
                                    <Box>
                                        <FormControl id="domain_name" isRequired mb={websiteForm.errors.domain_name ? 0 : 5}>
                                            <FormLabel>Domain name</FormLabel>
                                            <Input name='domain_name' type={'url'} value={websiteForm.values.domain_name} onChange={websiteForm.handleChange} onBlur={websiteForm.handleBlur} />
                                            <FormHelperText>E.g http://www.domain-name.co.za</FormHelperText>
                                            {websiteForm.errors.domain_name && <Text fontSize='sm' color='red.400'>{websiteForm.errors.domain_name}</Text>}
                                        </FormControl>
                                    </Box>
                                </HStack>
                                <Stack spacing={10} pt={2}>
                                    <Button
                                        type='submit'
                                        isLoading={is_adding_company_website_request}
                                        isDisabled={!websiteForm.isValid || is_adding_company_website_request}
                                        size="lg"
                                        colorScheme={'yellow'}
                                    >
                                        Submit request
                                    </Button>
                                </Stack>
                            </form>
                        </Stack>
                    </Box>
                </Stack>
                <ToastContainer />
            </Flex>
        </>
    );
};